import { IState } from 'shared/store';

export const selectDailyrentActionType = (state: IState) => {
  return state.dailyrentActionType;
};
